<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title162"></a>
<div class="verse"><span><em class="i">For this is wisdom; to love, to live</em><br/> <em class="i">To take what fate, or the gods, may give.</em><br/> <em class="i">To ask no question, to make no prayer,</em><br/> <em class="i">To kiss the lips and caress the hair.</em><br/> <em class="i">Speed passion’s ebb as you greet its flow</em><br/> <em class="i">To have</em>—<em class="i">to hold</em>—<em class="i">and</em>—<em class="i">in time</em>—<em class="i">let go!</em></span></div>
<div class="source"><span>—Laurence Hope</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821378_epi01.vue?12e26e0b